var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59103 12.0659L8.70716 12.9498C7.14505 14.5119 4.61239 14.5119 3.05028 12.9498V12.9498C1.48819 11.3877 1.48818 8.855 3.05027 7.2929L3.93415 6.409M12.0659 9.591L12.9498 8.70713C14.5119 7.14503 14.5119 4.61236 12.9498 3.05026V3.05026C11.3877 1.48816 8.85503 1.48816 7.29293 3.05024L6.40903 3.93413M9.76778 6.23222L6.23225 9.76776",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b1c04fe4e669ef9d05f5662fd9b82dca.svg";
export { ForwardRef as ReactComponent };